module.exports = __webpack_public_path__ + "img/product-02.0ba08be1.svg";